import { ResponseNode } from '../models/response-node.model';

export const mapProperty = (data: Array<ResponseNode>): Map<string, ResponseNode> => {
  if (!data) {
    return new Map<string, ResponseNode>();
  }

  return new Map<string, ResponseNode>(data.map((node: ResponseNode): [string, ResponseNode] => [node.id, node]));
};
